import React from "react";
import ManagementNavbar from "./ManagementNavbar";
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Grow,
    IconButton,
    Snackbar,
    TextField,
    Tooltip
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EmployeeData from "../../backend/dataservices/EmployeeData";
import Backend from "../../backend/Backend"
import AttendanceData from "../../backend/dataservices/AttendanceData";
import {DeleteForever} from "@mui/icons-material";
import Helpers from "../../utils/Helpers";


function createSuggestionsData(_name, _employee) {
    return {name: _name, employee: _employee};
}

function createBossSuggestionsData(_name, _diszi) {
    return {name: _name, diszi: _diszi};
}

function createLocationSuggestionsData(_id, _name) {
    return {id: _id, name: _name};
}

function ManagementEmployeesPage() {

    const [suggestions, setSuggestions] = React.useState([]);
    const [openSuggestion, setOpenSuggestion] = React.useState(false);
    const [openBossSuggestion, setOpenBossSuggestion] = React.useState(false);
    const [openLocationSuggestion, setOpenLocationSuggestion] = React.useState(false);
    const [suggestionValue, setSuggestionValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [createNewEmployee, setCreateNewEmployee] = React.useState(false);
    const [fullname, setFullname] = React.useState('');
    const [firstname, setFirstname] = React.useState('');
    const [lastname, setLastname] = React.useState('');
    const [gid, setGid] = React.useState('');
    const [costCenter, setCostCenter] = React.useState('');
    const [location, setLocation] = React.useState(null);
    const [boss, setBoss] = React.useState(null);
    const [notes, setNotes] = React.useState('');
    const [bossSuggestions, setBossSuggestions] = React.useState([]);
    const [locationSuggestions, setLocationSuggestions] = React.useState([]);
    const [originalData, setOriginalData] = React.useState(new Map());
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarText, setSnackbarText] = React.useState("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
    const [deletable, setDeletable] = React.useState(false);
    const [showDeleteButton, setShowDeleteButton] = React.useState(false);
    const [showEmployeeDeleteDialog, setShowEmployeeDeleteDialog] = React.useState(false);
    const [bossLoading, setBossLoading] = React.useState(true);
    const [locationLoading, setLocationLoading] = React.useState(true);


    React.useEffect(() => {
        (async () => {
            loadBossSuggestions().then(value => {
                setBossSuggestions(value);
            }).finally(() => setBossLoading(false));
            loadLocationSuggestions().then(value => {
                setLocationSuggestions(value);
            }).finally(() => setLocationLoading(false));

        })();
    }, [])

    async function loadBossSuggestions() {
        let tempSuggestions = [];
        await Backend.getData('/api/TAB_DISZI?fields=D_Diszi,D_Name').then(function (disziData) {
            if (!Array.isArray(disziData)) return;
            disziData.forEach(function (diszi) {
                tempSuggestions.push(createBossSuggestionsData(diszi.D_Name + ' (' + diszi.D_Diszi + ')', diszi.D_Diszi))
            });
        });
        return tempSuggestions;
    }

    async function loadLocationSuggestions() {
        let tempSuggestions = []
        await Backend.getData('/api/TAB_STANDORT').then(function (locations) {
            if (!Array.isArray(locations)) return;
            locations.forEach(function (location) {
                tempSuggestions.push(createLocationSuggestionsData(location.S_ID, location.S_Standort));
            });
        });
        return tempSuggestions;
    }

    function searchEmployee(name) {
        setLoading(true);
        EmployeeData.searchEmployeeByName(name).then(generateRows);

    }


    async function loadDataFromDatabase(rawEmployeeData) {
        let tempRows = [];
        for (const employee of rawEmployeeData) {
            tempRows.push(createSuggestionsData(employee.M_Name + ", " + employee.M_Vorname, employee));
        }
        return tempRows;
    }

    function generateRows(rawEmployeeData) {
        loadDataFromDatabase(rawEmployeeData).then(data => {
            setSuggestions(data);
            setLoading(false);
        });
    }

    function checkForDeletable(employee) {
        setShowDeleteButton(true);
        AttendanceData.fetchAllAttendancesForEmployee(employee["M_Pers-Nr"]).then(atts => {
            if (atts.length === 0) {
                setDeletable(true);
            } else {
                setDeletable(false);
            }
        });
    }

    function handleInputValue(newInputValue) {
        if (newInputValue != null) {
            setCreateNewEmployee(false);

            let employee = newInputValue.employee;
            setFirstname(employee.M_Vorname);
            setLastname(employee.M_Name);
            setFullname(newInputValue.name);
            setGid(employee['M_Pers-Nr']);
            setNotes(employee.M_Bemerkungen == null ? '' : employee.M_Bemerkungen);
            let disziFromID = getDisziFromID(employee.M_Diszi);
            setBoss(disziFromID);
            let locationFromID = getLocationFromID(employee.M_Standort);
            setLocation(locationFromID);
            setCostCenter(employee.M_Kostenstelle == null ? '' : employee.M_Kostenstelle);

            let map = new Map();
            map.set('firstname', employee.M_Vorname);
            map.set('lastname', employee.M_Name);
            map.set('fullname', newInputValue.name);
            map.set('gid', employee['M_Pers-Nr']);
            map.set('notes', employee.M_Bemerkungen == null ? '' : employee.M_Bemerkungen);
            map.set('boss', disziFromID);
            map.set('location', locationFromID);
            map.set('costCenter', employee.M_Kostenstelle == null ? '' : employee.M_Kostenstelle);
            setOriginalData(map);
            checkForDeletable(employee);
        } else {
            setShowDeleteButton(false);
        }
    }

    function getDisziFromID(diszi) {
        let data = null;
        bossSuggestions.forEach(function (boss) {
            if (diszi === boss.diszi) {
                data = createBossSuggestionsData(boss.name, boss.diszi);
            }
        });
        return data;
    }

    function getLocationFromID(id) {
        let data = null;
        locationSuggestions.forEach(function (location) {
            if (id === location.id) {
                data = createLocationSuggestionsData(id, location.name);
            }
        });
        return data;
    }

    function handleCreateNewEmployeeClick() {
        setCreateNewEmployee(true);
        clearAllData();
    }

    function clearAllData() {
        setFirstname('');
        setLastname('');
        setFullname('');
        setGid('');
        setNotes('');
        setBoss(null);
        setLocation(null);
        setCostCenter('');
    }

    function handleFullname(l, f) {
        if (f !== '' || l !== '') {
            setFullname(l + ', ' + f);
        } else {
            setFullname('');
        }
    }

    function handleFirstnameChange(event) {
        let value = event.target.value;
        setFirstname(value)
        handleFullname(lastname, value);
    }

    function handleLastnameChange(event) {
        let value = event.target.value;
        setLastname(value)
        handleFullname(value, firstname);
    }

    function discardChanges() {
        if (createNewEmployee) {
            clearAllData();
        } else {
            setFirstname(originalData.get('firstname'));
            setLastname(originalData.get('lastname'));
            setFullname(originalData.get('fullname'));
            setGid(originalData.get('gid'));
            setNotes(originalData.get('notes'));
            setBoss(originalData.get('boss'));
            setLocation(originalData.get('location'));
            setCostCenter(originalData.get('costCenter'));
        }
    }

    function saveEmployee() {
        if (createNewEmployee) {
            let employee = {
                M_TML: 0,
                M_Vorname: firstname,
                M_Name: lastname,
                M_Bemerkungen: notes,
                M_Diszi: boss.diszi,
                M_Kostenstelle: costCenter,
                "M_Pers-Nr": gid,
                M_Standort: location != null ? location.id : null,
            }

            Backend.postData('/api/TAB_MITARBEITER', employee).then(value => {
                setSnackbarSeverity('success');
                setSnackbarText('Mitarbeiter erfolgreich angelegt!');
                setSnackbarOpen(true);
            }, (error) => {
                setSnackbarSeverity('error');
                setSnackbarText('Ein unerwarteter Fehler ist aufgetreten');
                setSnackbarOpen(true);
            });
        } else {
            let employee = suggestionValue.employee;
            let uri = employee._links.self.href
            employee.M_Vorname = firstname;
            employee.M_Name = lastname;
            employee.M_Bemerkungen = notes;
            employee.M_Diszi = boss.diszi;
            employee.M_Kostenstelle = costCenter;
            employee["M_Pers-Nr"] = gid;
            employee.M_Standort = location != null ? location.id : null;
            if(employee.M_GebDat != null) {
                let date = new Date(employee.M_GebDat);
                date = Helpers.toMysqlFormat(date);
                employee.M_GebDat = date;
            }
            delete employee._links;

            Backend.putData(uri, employee).then(value => {
                setSnackbarText('Änderungen erfolgreich gespeichert');
                setSnackbarSeverity("success")
                setSnackbarOpen(true);
            }, (error) => {
                if (error.code === "ER_ROW_IS_REFERENCED_2") {
                    setSnackbarText('Dieser Mitarbeiter hat noch referenzierte Verwaltungen!');
                    setSnackbarSeverity("error")
                    setSnackbarOpen(true);
                } else {
                    setSnackbarSeverity('error');
                    setSnackbarText('Ein unerwarteter Fehler ist aufgetreten');
                    setSnackbarOpen(true);
                }
            });
        }
    }

    function closeSnackbar() {
        setSnackbarOpen(false);
    }

    function deleteEmployee() {
        setShowEmployeeDeleteDialog(false);
        if(gid != null && gid !== '') {
            EmployeeData.deleteEmployee(gid).then(value => {
                setSuggestionValue(null);
                setShowDeleteButton(false);
                setDeletable(false);
                setSnackbarText('Mitarbeiter gelöscht');
                setSnackbarSeverity("success")
                setSnackbarOpen(true);
            }, (error) => {
                setSnackbarText('Mitarbeiter konnte nicht gelöscht werden');
                setSnackbarSeverity("error")
                setSnackbarOpen(true);
            })
        }
    }

    function handleEmployeeDialogClose() {
        setShowEmployeeDeleteDialog(false);
    }

    return (
        <div>
            <ManagementNavbar initValue={"/management/employees"}/>
            <Box width={'100%'} sx={{
                borderBottom: '1px solid lightgrey',
                paddingTop: '10px',
                paddingBottom: '20px',
                marginBottom: '10px'
            }}>
                <Grid container spacing={4} style={{alignItems: 'center', justifyContent: 'center'}}>
                    <Grid item xs={1}/>
                    <Grid item xs={8}>
                        <Autocomplete options={suggestions}
                                      fullWidth
                                      open={openSuggestion}
                                      onOpen={() => {
                                          setOpenSuggestion(true)
                                      }}
                                      onClose={() => {
                                          setOpenSuggestion(false)
                                      }}
                                      inputValue={inputValue || ''}
                                      onInputChange={(event, newInputValue) => {
                                          setInputValue(newInputValue == null ? '' : newInputValue);
                                          if (newInputValue.length >= 2) {
                                              searchEmployee(newInputValue);
                                          }
                                      }}

                                      value={suggestionValue}
                                      onChange={(event, newInputValue) => {
                                          setSuggestionValue(newInputValue);
                                          handleInputValue(newInputValue);
                                      }}
                                      isOptionEqualToValue={(option, value) => option.name.includes(value.name)}
                                      getOptionLabel={(option) => option.name}
                                      renderOption={(props, option) => {
                                          return (
                                              <li {...props} key={option.employee['M_Pers-Nr']}>
                                                  {option.name}
                                              </li>
                                          );
                                      }}
                                      renderInput={(params => (
                                          <TextField
                                              {...params}
                                              variant={"outlined"}
                                              label={"Suche..."}
                                              sx={{width: '100%',}}
                                              InputProps={{
                                                  ...params.InputProps,
                                                  endAdornment: (
                                                      <React.Fragment>
                                                          {loading ? <CircularProgress color={"primary"}/> : null}
                                                          {params.InputProps.endAdornment}
                                                      </React.Fragment>
                                                  ),
                                              }}
                                          />
                                      ))}/>
                    </Grid>
                    <Grid item xs={2}>
                        <Button style={{width: '80%'}} variant={"contained"} endIcon={<AddIcon/>}
                                onClick={handleCreateNewEmployeeClick}>
                            Mitarbeiter anlegen
                        </Button>
                    </Grid>
                    <Grid item xs={1}>
                        {showDeleteButton ?
                            <Box marginLeft={10}>
                                <Tooltip
                                    title={deletable ? 'Mitarbeiter löschen' : 'Mitarbeiter kann nicht gelöscht werden, da auf diesen Schulungen gebucht sind'}>
                                    <span>
                                    <IconButton color={'error'} disabled={!deletable} size={'large'} onClick={() => {
                                        setShowEmployeeDeleteDialog(true);
                                    }}>
                                        <DeleteForever fontSize={'large'}/>
                                    </IconButton>
                                        </span>
                                </Tooltip>
                            </Box>
                            :
                            null
                        }
                    </Grid>
                </Grid>
            </Box>

            <Dialog open={showEmployeeDeleteDialog} onClose={handleEmployeeDialogClose}>
                <DialogTitle>
                    Mitarbeiter löschen
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Möchten Sie den Mitarbeiter {fullname} wirklich unwiderruflich löschen?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEmployeeDialogClose} variant={"text"}
                            style={{color: "gray"}}>Abbrechen</Button>
                    <Button color={"error"} variant={"text"} onClick={deleteEmployee}>Löschen</Button>
                </DialogActions>
            </Dialog>



            {suggestionValue != null || createNewEmployee ?
                <Card elevation={3} style={{width: '80%', margin: '5% 10% 0 10%'}}>
                    <CardHeader style={{borderBottom: '1px solid lightgrey'}} title={fullname} action={"GID: " + gid}/>
                    <CardContent>
                        <Grid container spacing={{xs: 2, md: 5}} width={'100%'}>
                            <Grid item xs={4}>
                                <TextField variant={'standard'} label={'Vorname'} required fullWidth value={firstname}
                                           onChange={handleFirstnameChange}/>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField variant={'standard'} label={'Nachname'} required fullWidth value={lastname}
                                           onChange={handleLastnameChange}/>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField variant={'standard'} label={'GID'} required fullWidth value={gid}
                                           onChange={(event) => setGid(event.target.value)}/>
                            </Grid>

                            <Grid item xs={6}>
                                <Autocomplete options={bossSuggestions}
                                              fullWidth
                                              open={openBossSuggestion}
                                              onOpen={() => {
                                                  setOpenBossSuggestion(true)
                                              }}
                                              onClose={() => {
                                                  setOpenBossSuggestion(false)
                                              }}

                                              value={boss}
                                              onChange={(event, newInputValue) => {
                                                  setBoss(newInputValue);
                                              }}
                                              isOptionEqualToValue={(option, value) => option.name.includes(value.name)}
                                              getOptionLabel={(option) => option.name}
                                              renderInput={(params => (
                                                  <TextField
                                                      {...params}
                                                      required
                                                      variant={"standard"}
                                                      label={"Diszi"}
                                                      fullWidth
                                                      InputProps={{
                                                          ...params.InputProps,
                                                          endAdornment: (
                                                              <React.Fragment>
                                                                  {bossLoading ?
                                                                      <CircularProgress color={"primary"}/> : null}
                                                                  {params.InputProps.endAdornment}
                                                              </React.Fragment>
                                                          ),
                                                      }}
                                                  />
                                              ))}/>

                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete options={locationSuggestions}
                                              fullWidth
                                              open={openLocationSuggestion}
                                              onOpen={() => {
                                                  setOpenLocationSuggestion(true)
                                              }}
                                              onClose={() => {
                                                  setOpenLocationSuggestion(false)
                                              }}

                                              value={location}
                                              onChange={(event, newInputValue) => {
                                                  setLocation(newInputValue);
                                              }}
                                              isOptionEqualToValue={(option, value) => option.name.includes(value.name)}
                                              getOptionLabel={(option) => option.name}
                                              renderInput={(params => (
                                                  <TextField
                                                      {...params}
                                                      variant={"standard"}
                                                      label={"Standort"}
                                                      fullWidth
                                                      InputProps={{
                                                          ...params.InputProps,
                                                          endAdornment: (
                                                              <React.Fragment>
                                                                  {locationLoading ?
                                                                      <CircularProgress color={"primary"}/> : null}
                                                                  {params.InputProps.endAdornment}
                                                              </React.Fragment>
                                                          ),
                                                      }}
                                                  />
                                              ))}/>

                            </Grid>

                            <Grid item xs={12}>
                                <TextField variant={'standard'} label={'Bemerkungen'} fullWidth value={notes}
                                           onChange={(event) => setNotes(event.target.value)}/>
                            </Grid>

                            <Grid item xs={4}>
                                <Button disabled={
                                    originalData.get('firstname') === firstname
                                    && originalData.get('lastname') === lastname
                                    && originalData.get('fullname') === fullname
                                    && originalData.get('gid') === gid
                                    && originalData.get('notes') === notes
                                    && originalData.get('boss') === boss
                                    && originalData.get('location') === location
                                    && originalData.get('costCenter') === costCenter} fullWidth style={{color: "gray"}}
                                        onClick={discardChanges}>Änderungen verwerfen</Button>
                            </Grid>
                            <Grid item xs={4}/>
                            <Grid item xs={4}>
                                <Button disabled={(originalData.get('firstname') === firstname
                                        && originalData.get('lastname') === lastname
                                        && originalData.get('fullname') === fullname
                                        && originalData.get('gid') === gid
                                        && originalData.get('notes') === notes
                                        && originalData.get('boss') === boss
                                        && originalData.get('location') === location
                                        && originalData.get('costCenter') === costCenter)
                                    || firstname === '' || lastname === '' || gid === '' || boss == null}
                                        fullWidth color={"primary"} onClick={saveEmployee}>Speichern</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                :
                null
            }
            <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={closeSnackbar}
                      anchorOrigin={{vertical: "top", horizontal: "right"}} TransitionComponent={Grow}>
                <Alert onClose={closeSnackbar} severity={snackbarSeverity} sx={{width: '100%'}}>
                    {snackbarText}
                </Alert>
            </Snackbar>
        </div>

    )

}

export default ManagementEmployeesPage;